import { PageHeaderRoot } from "./page-header";
import { PageHeaderActions } from "./parts/view-actions";
import { PageHeaderTabSelect } from "./parts/tab-select";
import { PageHeaderTabs } from "./parts/tabs";
import { PageHeaderTitle } from "./parts/view-title";

export { PAGE_HEADER_TABS_LABEL } from "./messages";
export { usePageHeaderTabs } from "./use-page-header-tabs";
export type { PageHeaderTabItem, UsePageHeaderTabsOptions } from "./use-page-header-tabs";
export type {
  PageHeaderActionsProps,
  PageHeaderClassNames,
  PageHeaderProps,
  PageHeaderRootAttributes,
  PageHeaderTabsProps,
  PageHeaderTitleProps,
  PageHeaderVariant,
  PageHeaderViewModel,
  UsePageHeaderOptions,
} from "./types-page-header";

/** Cabeçalho de página com abas por rota (`PageHeader.Root/Title/Tabs/TabSelect/Actions`). */
export const PageHeader = {
  Root: PageHeaderRoot,
  Title: PageHeaderTitle,
  Tabs: PageHeaderTabs,
  TabSelect: PageHeaderTabSelect,
  Actions: PageHeaderActions,
};
